


























































































































































































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import {SiteEntity} from "@/entity/SiteEntity";
import {
    cleanDomain,
    isLeaveConfirmed,
    registerUnsavedGuard,
    unregisterUnsavedGuard,
    UnsavedGuard,
} from "@/store";

// Kaydedilmemiş değişiklik varken ekrandan çıkarken sorulsun
Component.registerHooks(["beforeRouteLeave"]);

/** "seo" ayar bloğunda bu ekranın yönettiği anahtarlar */
const SEO_KEYS = [
    "ga4Id", "gtmId",
    "adsId", "adsLeadLabel", "adsPhoneLabel", "adsWhatsappLabel",
    "googleSiteVerification", "googleVerificationFile", "bingVerification", "yandexVerification",
    "robotsTxt",
];
/** "site" ayar bloğunda bu ekranın yönettiği anahtarlar (ek <head>/<body> kodu) */
const SITE_KEYS = ["analytics", "remarketing"];

type SeoForm = { [key: string]: string };
type StatusType = "ok" | "info" | "warn";
interface FieldStatus {
    type: StatusType;
    text: string;
    code?: string;
    link?: string;
}
interface FieldDef {
    key: string;
    label: string;
    placeholder: string;
    hint: string;
}
interface TrackingPreview {
    site_id?: number | string | null;
    site_name?: string;
    domain?: string;
    site_url?: string;
    ga4?: string;
    gtm?: string;
    ads?: string;
    labels?: { lead?: string; phone?: string; whatsapp?: string };
    google_verification?: string;
    bing_verification?: string;
    yandex_verification?: string;
    verification_file?: string;
    verification_file_url?: string;
    sitemap_url?: string;
    robots_url?: string;
    head_code_present?: boolean;
    body_code_present?: boolean;
    head_html?: string;
    body_html?: string;
    warnings?: string[];
}

function emptyForm(keys: string[]): SeoForm {
    const form: SeoForm = {};
    keys.forEach((key: string) => form[key] = "");
    return form;
}

/* -----------------------------------------------------------------------
 * Değer normalleştirme — sitedeki Tracking.php kurallarının aynısı; alan
 * altında "sitede kullanılacak değer" anında gösterilsin diye. Kesin sonuç
 * kaydettikten sonra "Sitede şu an basılan kodlar" bölümündedir.
 * --------------------------------------------------------------------- */
function clean(value: any): string {
    const text = String(value === null || value === undefined ? "" : value).trim();
    return ["null", "undefined", "false"].indexOf(text.toLowerCase()) !== -1 ? "" : text;
}
function normGa4(value: any): string {
    const m = clean(value).match(/\bG-[A-Z0-9]{4,}\b/i);
    return m ? m[0].toUpperCase() : "";
}
function normGtm(value: any): string {
    const m = clean(value).match(/\bGTM-[A-Z0-9]{4,}\b/i);
    return m ? m[0].toUpperCase() : "";
}
function normAds(value: any): string {
    const text = clean(value);
    const m = text.match(/\bAW-(\d+)\b/i);
    if (m) {
        return "AW-" + m[1];
    }
    return /^\d{5,}$/.test(text) ? "AW-" + text : "";
}
/**
 * Sitedeki daha sıkı kuralın aynısı: eski kopya "https://x.com/?a" gibi
 * çöpten de etiket çıkarıp "Gönderilecek send_to" gösteriyordu, site ise
 * boş sayıp dönüşüm göndermiyordu. Tanınmayan değer '' → "Etiket tanınamadı".
 */
function normLabel(value: any): string {
    let text = clean(value);
    if (text === "") {
        return "";
    }
    // send_to değeri yapıştırıldıysa: 'AW-123/AbC-dEf_1'
    const sendTo = text.match(/\bAW-\d+\s*\/\s*([A-Za-z0-9_-]+)/i);
    if (sendTo) {
        return sendTo[1];
    }
    if (/^AW-\d+$/i.test(text)) {
        return "";
    }
    // HTML, adres ya da sorgu dizesi etiket değildir
    if (/[<>?]/.test(text) || text.indexOf("://") !== -1) {
        return "";
    }
    const slash = text.lastIndexOf("/");
    if (slash !== -1) {
        text = text.substring(slash + 1);
    }
    // PHP trim($value, " \t\r\n'\"`;,)}") ile aynı karakterler
    text = text.replace(/^[ \t\r\n'"`;,)}]+|[ \t\r\n'"`;,)}]+$/g, "");
    // Yalnızca tamamı etiket biçimindeyse kabul (serbest metin kırpılmaz)
    return /^[A-Za-z0-9_-]{6,}$/.test(text) ? text : "";
}
function normVerification(value: any): string {
    let text = clean(value);
    if (text === "") {
        return "";
    }
    const content = text.match(/content\s*=\s*["']?\s*([^"'\s>]+)/i);
    const named = text.match(/(?:google-site-verification|msvalidate\.01|yandex-verification)\s*[=:]\s*["']?\s*([^"'\s>]+)/i);
    if (content) {
        text = content[1];
    } else if (named) {
        text = named[1];
    }
    text = text.replace(/^[\s'"\/>]+|[\s'"\/>]+$/g, "");
    if (/^google[a-z0-9]+(\.html)?$/i.test(text)) {
        return "";
    }
    return /^[A-Za-z0-9_\-+=.\/]{4,255}$/.test(text) ? text : "";
}
function normVerificationFile(value: any): string {
    const text = clean(value);
    const file = text.match(/google[a-z0-9]{6,}\.html/i);
    if (file) {
        return file[0];
    }
    const bare = text.match(/\bgoogle[a-z0-9]{6,}\b/i);
    return bare ? bare[0] + ".html" : "";
}
function uniqueUpper(list: string[] | null): string[] {
    const out: string[] = [];
    (list || []).forEach((item: string) => {
        const id = item.toUpperCase();
        if (out.indexOf(id) === -1) {
            out.push(id);
        }
    });
    return out;
}

@Component({})
export default class TeknikSeo extends Vue {
    seo: SeoForm = emptyForm(SEO_KEYS);
    site: SeoForm = emptyForm(SITE_KEYS);
    /** GET ile gelen, bu ekranın bilmediği anahtarlar — kayıtta geri gönderilir, silinmez */
    extraSeo: SeoForm = {};

    /** Formdaki verinin ait olduğu şube (sunucunun döndürdüğü _site_id) */
    loadedSiteId: number | null = null;
    loadedSiteName: string = "";
    /** Yüklemeler üst üste binerse yalnızca en sonuncusu forma yazılır */
    loadToken: number = 0;
    loading: boolean = false;
    saving: boolean = false;
    loadError: string = "";
    snapshot: string = "";
    lastSavedAt: string = "";
    result: { ok: boolean; text: string; visible: boolean } | null = null;
    snackbar = {enabled: false, text: "", color: "success"};

    preview: TrackingPreview | null = null;
    previewLoading: boolean = false;
    previewError: string = "";

    /** Şube seçicinin sorduğu "kaydedilmemiş değişiklik var mı" (reaktif veri değil) */
    unsavedGuard!: UnsavedGuard | null;

    gaFields: FieldDef[] = [
        {
            key: "ga4Id",
            label: "Google Analytics 4 ölçüm kimliği",
            placeholder: "G-XXXXXXXXXX",
            hint: "Analytics → Yönetici → Veri akışları → web akışı → “Ölçüm kimliği” (G- ile başlar).",
        },
        {
            key: "gtmId",
            label: "Google Tag Manager kapsayıcı kimliği",
            placeholder: "GTM-XXXXXXX",
            hint: "Tag Manager'da çalışma alanının üstündeki GTM- ile başlayan kimlik. Kullanmıyorsanız boş bırakın.",
        },
    ];
    adsFields: FieldDef[] = [
        {
            key: "adsId",
            label: "Google Ads kimliği",
            placeholder: "AW-123456789",
            hint: "send_to değerinde eğik çizgiden önceki kısım (AW- ile başlar). 123-456-7890 biçimindeki müşteri kimliği değildir.",
        },
        {
            key: "adsLeadLabel",
            label: "Form gönderimi — dönüşüm etiketi",
            placeholder: "AbCdEfGh12",
            hint: "İletişim formu gönderilip teşekkür sayfası açıldığında sayılır (sayfa yenilenirse ya da doğrudan açılırsa tekrar sayılmaz).",
        },
        {
            key: "adsPhoneLabel",
            label: "Telefon tıklaması — dönüşüm etiketi",
            placeholder: "AbCdEfGh12",
            hint: "Sitedeki telefon numarasına (tel: bağlantısı) tıklanınca sayılır.",
        },
        {
            key: "adsWhatsappLabel",
            label: "WhatsApp tıklaması — dönüşüm etiketi",
            placeholder: "AbCdEfGh12",
            hint: "Sitedeki WhatsApp bağlantısına tıklanınca sayılır.",
        },
    ];
    scFields: FieldDef[] = [
        {
            key: "googleSiteVerification",
            label: "Search Console — HTML etiketi",
            placeholder: "content değeri ya da <meta ...> etiketinin tamamı",
            hint: "HTML etiketi yöntemi — content değerini ya da tüm <meta> etiketini yapıştırabilirsiniz.",
        },
        {
            key: "googleVerificationFile",
            label: "Search Console — HTML dosyası",
            placeholder: "google1a2b3c4d5e6f7g8h.html",
            hint: "HTML dosyası yöntemi — dosya adını yazın, örn. google1a2b3c.html. Dosyayı yüklemeniz gerekmez; site bu adreste doğru içeriği kendisi sunar.",
        },
        {
            key: "bingVerification",
            label: "Bing Webmaster Tools doğrulama kodu",
            placeholder: "msvalidate.01 content değeri",
            hint: "<meta name=\"msvalidate.01\" …> etiketinin content değeri ya da etiketin tamamı.",
        },
        {
            key: "yandexVerification",
            label: "Yandex Webmaster doğrulama kodu",
            placeholder: "yandex-verification content değeri",
            hint: "<meta name=\"yandex-verification\" …> etiketinin content değeri ya da etiketin tamamı.",
        },
    ];

    /* ------------------------------------------------------------------
     * Şube
     * ---------------------------------------------------------------- */

    /** Üst bardaki aktif şube; API istekleri (X-Site-Id) bununla gider */
    get activeSiteId(): number | null {
        const id = this.$store.getters.activeSiteId;
        return id === null || id === undefined || id === "" ? null : Number(id);
    }

    /** Formdaki verinin ait olduğu şube kaydı */
    get formSite(): SiteEntity | null {
        const sites: SiteEntity[] = this.$store.getters.sites || [];
        const id = this.loadedSiteId !== null ? this.loadedSiteId : this.activeSiteId;
        return sites.find((s: SiteEntity) => Number(s.site_id) === Number(id)) || null;
    }

    get branchName(): string {
        return this.loadedSiteName || (this.formSite ? this.formSite.name : "") || this.$store.getters.activeSiteName;
    }

    get publicDomain(): string {
        return this.formSite ? cleanDomain(this.formSite.domain) : "";
    }

    /** Canlı adres (Search Console'a verilecek): https://<alan adı>/ */
    get publicBase(): string {
        return this.$store.getters.publicSiteUrlFor(this.formSite);
    }

    /** Açılabilir site adresi: yerelde http://<site_key>.localhost:<port>/ */
    get siteBase(): string {
        return this.$store.getters.siteUrlFor(this.formSite);
    }

    siteLink(path: string): string {
        const base = this.siteBase;
        if (!base) {
            return "";
        }
        const q = base.indexOf("?");
        return q === -1 ? base + path : base.substring(0, q) + path + base.substring(q);
    }

    /** Form başka şubeye ait (şube değişti, yeniden yükleme bekleniyor) */
    get siteMismatch(): boolean {
        return this.loadedSiteId !== null && this.activeSiteId !== null
            && Number(this.loadedSiteId) !== Number(this.activeSiteId);
    }

    get canSave(): boolean {
        return !this.loading && !this.saving && this.loadError === ""
            && this.loadedSiteId !== null && !this.siteMismatch;
    }

    /* ------------------------------------------------------------------
     * Anlık kontroller (kaydı engellemez)
     * ---------------------------------------------------------------- */

    get norm() {
        const ads = normAds(this.seo.adsId);
        let adsFromLabel = "";
        ["adsLeadLabel", "adsPhoneLabel", "adsWhatsappLabel"].forEach((key: string) => {
            const m = clean(this.seo[key]).match(/\bAW-(\d+)\s*\//i);
            if (!adsFromLabel && m) {
                adsFromLabel = "AW-" + m[1];
            }
        });
        return {
            ga4: normGa4(this.seo.ga4Id),
            gtm: normGtm(this.seo.gtmId),
            ads: ads,
            // Ads kimliği boşsa etikete yapıştırılan send_to'dan alınır (site de böyle yapar)
            adsEffective: ads || adsFromLabel,
            adsLeadLabel: normLabel(this.seo.adsLeadLabel),
            adsPhoneLabel: normLabel(this.seo.adsPhoneLabel),
            adsWhatsappLabel: normLabel(this.seo.adsWhatsappLabel),
            googleSiteVerification: normVerification(this.seo.googleSiteVerification),
            verificationFile: normVerificationFile(this.seo.googleVerificationFile)
                || normVerificationFile((clean(this.seo.googleSiteVerification).match(/google[a-z0-9]{6,}\.html/i) || [""])[0]),
            bingVerification: normVerification(this.seo.bingVerification),
            yandexVerification: normVerification(this.seo.yandexVerification),
        };
    }

    /** Ek kodlarda geçen GTM / GA4 / Ads kimlikleri */
    get codeIds() {
        const code = clean(this.site.analytics) + "\n" + clean(this.site.remarketing);
        return {
            gtm: uniqueUpper(code.match(/\bGTM-[A-Z0-9]{4,}\b/gi)),
            ga4: uniqueUpper(code.match(/\bG-[A-Z0-9]{4,}\b/gi)),
            ads: uniqueUpper(code.match(/\bAW-\d+\b/gi)),
        };
    }

    get codeIdList(): string[] {
        const ids = this.codeIds;
        return ids.gtm.concat(ids.ga4, ids.ads);
    }

    get status(): { [key: string]: FieldStatus | null } {
        const n = this.norm;
        const ids = this.codeIds;
        const raw = (key: string) => clean(this.seo[key]);
        const out: { [key: string]: FieldStatus | null } = {};

        // GA4
        out.ga4Id = null;
        if (raw("ga4Id") !== "") {
            if (n.ga4 === "") {
                out.ga4Id = {
                    type: "warn",
                    text: /\bUA-\d+/i.test(raw("ga4Id"))
                        ? "Bu eski Universal Analytics (UA-) kimliği; artık veri toplamıyor. G- ile başlayan ölçüm kimliğini girin."
                        : (normGtm(raw("ga4Id")) ? "Bu bir GTM kimliği; Tag Manager alanına girin." : "GA4 kimliği tanınamadı; G-XXXXXXXXXX biçiminde olmalı."),
                };
            } else if (ids.ga4.some((id: string) => id !== n.ga4)) {
                out.ga4Id = {
                    type: "warn",
                    text: "Ek kodlarda farklı bir GA4 kimliği var (" + ids.ga4.filter((id: string) => id !== n.ga4).join(", ") + "); veriler iki ayrı mülke gider. Alandan kullanılacak:",
                    code: n.ga4,
                };
            } else if (ids.ga4.indexOf(n.ga4) !== -1) {
                out.ga4Id = {type: "info", text: "Bu GA4 kimliği ek kodlarda da var; site aynı kimliği ikinci kez basmaz. Sitede kullanılacak:", code: n.ga4};
            } else if (n.gtm !== "" || ids.gtm.length > 0) {
                out.ga4Id = {
                    type: "info",
                    text: "GTM de kullanılıyor (" + (n.gtm || ids.gtm.join(", ")) + "): GTM içinde aynı GA4 etiketi varsa ziyaretler iki kez sayılır. Sitede kullanılacak:",
                    code: n.ga4,
                };
            } else {
                out.ga4Id = {type: "ok", text: "Sitede kullanılacak:", code: n.ga4};
            }
        }

        // GTM
        out.gtmId = null;
        if (raw("gtmId") !== "") {
            if (n.gtm === "") {
                out.gtmId = {
                    type: "warn",
                    text: normGa4(raw("gtmId")) ? "Bu bir GA4 kimliği; Google Analytics 4 alanına girin." : "GTM kimliği tanınamadı; GTM-XXXXXXX biçiminde olmalı.",
                };
            } else if (ids.gtm.some((id: string) => id !== n.gtm)) {
                out.gtmId = {
                    type: "warn",
                    text: "Ek kodlarda farklı bir GTM kapsayıcısı var (" + ids.gtm.filter((id: string) => id !== n.gtm).join(", ") + "); iki kapsayıcı birlikte çalışır, tek kapsayıcı kullanın. Alandan kullanılacak:",
                    code: n.gtm,
                };
            } else if (ids.gtm.indexOf(n.gtm) !== -1) {
                out.gtmId = {type: "info", text: "Bu GTM ek kodlarda da var; site ikinci kez basmaz. Karışıklık olmaması için birini silebilirsiniz:", code: n.gtm};
            } else {
                out.gtmId = {type: "ok", text: "Sitede kullanılacak:", code: n.gtm};
            }
        }

        // Google Ads kimliği
        out.adsId = null;
        if (raw("adsId") !== "") {
            if (n.ads === "") {
                out.adsId = {
                    type: "warn",
                    text: /^\d{3}-\d{3}-\d{4}$/.test(raw("adsId"))
                        ? "Bu Google Ads müşteri kimliği; burada dönüşüm kimliği (AW-…) gerekir."
                        : "Google Ads kimliği tanınamadı; AW-123456789 biçiminde olmalı.",
                };
            } else {
                out.adsId = {type: "ok", text: "Sitede kullanılacak:", code: n.ads};
            }
        } else if (n.adsEffective !== "") {
            out.adsId = {type: "info", text: "Alan boş; etikete yapıştırılan send_to değerindeki kimlik kullanılacak:", code: n.adsEffective};
        }

        // Dönüşüm etiketleri
        const labelKeys: { [key: string]: string } = {
            adsLeadLabel: n.adsLeadLabel,
            adsPhoneLabel: n.adsPhoneLabel,
            adsWhatsappLabel: n.adsWhatsappLabel,
        };
        Object.keys(labelKeys).forEach((key: string) => {
            const label = labelKeys[key];
            out[key] = null;
            if (raw(key) === "") {
                return;
            }
            const labelAds = raw(key).match(/\bAW-(\d+)\s*\//i);
            if (label === "") {
                out[key] = {
                    type: "warn",
                    text: /^AW-\d+$/i.test(raw(key))
                        ? "Bu yalnızca Ads kimliği; eğik çizgiden sonraki etiketi de girin (AW-123456789/ABCdef12 → ABCdef12)."
                        : "Etiket tanınamadı; send_to değerindeki “/” işaretinden sonraki kısmı girin.",
                };
            } else if (n.adsEffective === "") {
                out[key] = {type: "warn", text: "Google Ads kimliği boş; bu dönüşüm gönderilemez."};
            } else if (labelAds && "AW-" + labelAds[1] !== n.adsEffective) {
                out[key] = {
                    type: "warn",
                    text: "Etiketteki kimlik (AW-" + labelAds[1] + ") Ads kimliğinden (" + n.adsEffective + ") farklı; dönüşüm " + n.adsEffective + " hesabına gönderilir.",
                };
            } else {
                out[key] = {type: "ok", text: "Gönderilecek send_to:", code: n.adsEffective + "/" + label};
            }
        });

        // Doğrulama etiketleri
        const metas: { [key: string]: { value: string; name: string } } = {
            googleSiteVerification: {value: n.googleSiteVerification, name: "google-site-verification"},
            bingVerification: {value: n.bingVerification, name: "msvalidate.01"},
            yandexVerification: {value: n.yandexVerification, name: "yandex-verification"},
        };
        Object.keys(metas).forEach((key: string) => {
            out[key] = null;
            if (raw(key) === "") {
                return;
            }
            if (metas[key].value === "") {
                out[key] = {
                    type: "warn",
                    text: key === "googleSiteVerification" && /google[a-z0-9]{6,}(\.html)?/i.test(raw(key))
                        ? "Bu bir HTML dosyası adı; “Search Console — HTML dosyası” alanına yazın (site bunu dosya yöntemi olarak kullanır)."
                        : "Değer tanınamadı; etiketin tamamını ya da yalnızca content=\"…\" içindeki değeri yapıştırın.",
                };
            } else {
                out[key] = {type: "ok", text: "Basılacak etiket:", code: "<meta name=\"" + metas[key].name + "\" content=\"" + metas[key].value + "\">"};
            }
        });

        // HTML dosyası yöntemi
        out.googleVerificationFile = null;
        const fileUrl = n.verificationFile && this.publicBase ? this.publicBase + n.verificationFile : "";
        if (raw("googleVerificationFile") !== "") {
            if (n.verificationFile === "" || normVerificationFile(raw("googleVerificationFile")) === "") {
                out.googleVerificationFile = {type: "warn", text: "Dosya adı tanınamadı; google1a2b3c4d5e6f7g8h.html biçiminde olmalı."};
            } else {
                out.googleVerificationFile = {type: "ok", text: "Doğrulama adresi:", link: fileUrl, code: fileUrl ? "" : n.verificationFile};
            }
        } else if (n.verificationFile !== "") {
            out.googleVerificationFile = {type: "info", text: "HTML etiketi alanındaki dosya adı kullanılacak:", link: fileUrl, code: fileUrl ? "" : n.verificationFile};
        }
        if (out.googleVerificationFile && out.googleVerificationFile.type !== "warn" && this.$store.getters.isLocalMode && this.siteBase) {
            out.googleVerificationFile.text = "Doğrulama adresi (yerelde denemek için " + this.siteLink(n.verificationFile) + "):";
        }

        // robots.txt
        out.robotsTxt = null;
        const robots = clean(this.seo.robotsTxt);
        if (robots !== "") {
            const sitemapHosts: string[] = [];
            robots.replace(/^\s*sitemap\s*:\s*(\S+)/gim, (all: string, url: string) => {
                sitemapHosts.push(cleanDomain(url).replace(/^www\./, ""));
                return all;
            });
            const ownHost = this.publicDomain.replace(/^www\./, "");
            if (/^\s*disallow\s*:\s*\/\s*$/im.test(robots)) {
                out.robotsTxt = {type: "warn", text: "“Disallow: /” satırı tüm siteyi arama motorlarına kapatır. Bilerek yapmadıysanız kaldırın."};
            } else if (ownHost && sitemapHosts.some((host: string) => host !== ownHost)) {
                out.robotsTxt = {type: "warn", text: "Sitemap satırı başka bir alan adını gösteriyor; bu şubenin adresi olmalı:", code: this.publicBase + "sitemap.xml"};
            } else if (sitemapHosts.length === 0) {
                out.robotsTxt = {type: "info", text: "Sitemap satırı yok; eklemeniz önerilir:", code: "Sitemap: " + (this.publicBase ? this.publicBase + "sitemap.xml" : "https://alanadi/sitemap.xml")};
            }
        }

        return out;
    }

    statusClass(type: StatusType): string {
        return type === "warn" ? "warning--text" : (type === "info" ? "info--text" : "success--text");
    }

    statusIcon(type: StatusType): string {
        return type === "warn" ? "mdi-alert" : (type === "info" ? "mdi-information" : "mdi-check-circle");
    }

    /* ------------------------------------------------------------------
     * Önizleme (GET /admin/tracking — sunucunun gerçekten bastığı kod)
     * ---------------------------------------------------------------- */

    get previewWarnings(): string[] {
        const warnings = this.preview && Array.isArray(this.preview.warnings) ? this.preview.warnings : [];
        return warnings.map((w: any) => String(w));
    }

    get previewDomainText(): string {
        if (this.preview && this.preview.site_url) {
            return String(this.preview.site_url);
        }
        return this.publicBase || "canlı alan adı";
    }

    get previewRows() {
        const p = this.preview;
        if (!p) {
            return [];
        }
        const labels = p.labels || {};
        const ads = p.ads || "";
        const sendTo = (label?: string) => {
            if (!label) {
                return "";
            }
            return ads ? ads + "/" + label : label + " (Ads kimliği yok — gönderilmiyor)";
        };
        const meta = (name: string, content?: string) => content ? "<meta name=\"" + name + "\" content=\"" + content + "\">" : "";
        return [
            {name: "Google Analytics 4", value: p.ga4 || ""},
            {name: "Google Tag Manager", value: p.gtm || ""},
            {name: "Google Ads kimliği", value: ads},
            {name: "Form gönderimi dönüşümü", value: sendTo(labels.lead)},
            {name: "Telefon tıklaması dönüşümü", value: sendTo(labels.phone)},
            {name: "WhatsApp tıklaması dönüşümü", value: sendTo(labels.whatsapp)},
            {name: "Search Console etiketi", value: meta("google-site-verification", p.google_verification)},
            {name: "Search Console HTML dosyası", value: p.verification_file_url || p.verification_file || "", link: p.verification_file_url || ""},
            {name: "Bing etiketi", value: meta("msvalidate.01", p.bing_verification)},
            {name: "Yandex etiketi", value: meta("yandex-verification", p.yandex_verification)},
            {name: "Site haritası", value: p.sitemap_url || "", link: p.sitemap_url || ""},
            {name: "robots.txt", value: p.robots_url || "", link: p.robots_url || ""},
            {name: "Ek <head> kodu", value: p.head_code_present ? "Var — basılıyor" : ""},
            {name: "Ek <body> kodu", value: p.body_code_present ? "Var — basılıyor" : ""},
        ];
    }

    async loadPreview() {
        const token = this.loadToken;
        this.previewLoading = true;
        this.previewError = "";
        try {
            const response = await this.$http.get("tracking");
            if (token !== this.loadToken) {
                return;
            }
            const data = response.data as TrackingPreview;
            if (!data || typeof data !== "object") {
                throw new Error("Sunucudan beklenmeyen yanıt geldi.");
            }
            if (data.site_id !== undefined && data.site_id !== null && this.loadedSiteId !== null
                && Number(data.site_id) !== Number(this.loadedSiteId)) {
                // Önizleme formdaki şubeyle aynı şubeye ait olmalı
                throw new Error("Önizleme başka bir şubeye ait geldi; sayfayı yenileyin.");
            }
            this.preview = data;
        } catch (e) {
            if (token === this.loadToken) {
                this.preview = null;
                this.previewError = "Önizleme alınamadı: " + this.errorText(e);
            }
        } finally {
            if (token === this.loadToken) {
                this.previewLoading = false;
            }
        }
    }

    /* ------------------------------------------------------------------
     * Yükle / kaydet
     * ---------------------------------------------------------------- */

    serialize(): string {
        const values: SeoForm = {};
        SEO_KEYS.forEach((key: string) => values["seo." + key] = clean(this.seo[key]));
        SITE_KEYS.forEach((key: string) => values["site." + key] = clean(this.site[key]));
        return JSON.stringify(values);
    }

    get dirty(): boolean {
        return this.snapshot !== "" && this.serialize() !== this.snapshot;
    }

    resetForm() {
        this.seo = emptyForm(SEO_KEYS);
        this.site = emptyForm(SITE_KEYS);
        this.extraSeo = {};
        this.loadedSiteId = null;
        this.loadedSiteName = "";
        this.snapshot = "";
        this.preview = null;
        this.previewError = "";
    }

    async load() {
        const token = ++this.loadToken;
        this.loading = true;
        this.loadError = "";
        try {
            const [seoResponse, siteResponse] = await Promise.all([
                this.$http.get("config/seo"),
                this.$http.get("config/site"),
            ]);
            if (token !== this.loadToken) {
                return; // bu arada şube değişti; daha yeni yükleme geçerli
            }
            const seoData = seoResponse.data;
            const siteData = siteResponse.data;
            if (!seoData || typeof seoData !== "object" || !siteData || typeof siteData !== "object") {
                throw new Error("Sunucudan beklenmeyen yanıt geldi.");
            }
            const seoSiteId = seoData._site_id !== undefined && seoData._site_id !== null ? Number(seoData._site_id) : this.activeSiteId;
            const siteSiteId = siteData._site_id !== undefined && siteData._site_id !== null ? Number(siteData._site_id) : this.activeSiteId;
            if (seoSiteId !== siteSiteId) {
                throw new Error("Ayarlar iki farklı şubeden geldi; sayfayı yenileyin.");
            }
            if (this.activeSiteId !== null && seoSiteId !== null && seoSiteId !== this.activeSiteId) {
                // Sunucu başka şubeyi döndürdü (ör. seçili şube silinmiş);
                // bu veriyle kayıt yapılırsa yanlış şubeye yazılırdı.
                throw new Error("Sunucu seçili şubeyi tanımadı; üstteki şube seçicisinden şubeyi yeniden seçin.");
            }

            const seo = emptyForm(SEO_KEYS);
            const extra: SeoForm = {};
            Object.keys(seoData).forEach((key: string) => {
                const value = seoData[key];
                if (SEO_KEYS.indexOf(key) !== -1) {
                    seo[key] = clean(value);
                    return;
                }
                // Panelin bilmediği anahtarlar olduğu gibi korunur (eski
                // kayıtta Teknik SEO'yu kaydetmek bilinmeyen anahtarları
                // siliyordu). Nesne/null FormData'da "[object Object]"/"null"
                // metnine dönüşeceği için yalnızca düz değerler gönderilir.
                if (key.indexOf("_site_") === 0 || key === "googleVerification" || /_file$/.test(key)) {
                    return;
                }
                if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
                    extra[key] = String(value);
                }
            });
            // Eski anahtar (googleVerification) yalnızca yeni alan boşsa gösterilir
            if (seo.googleSiteVerification === "" && clean(seoData.googleVerification) !== "") {
                seo.googleSiteVerification = clean(seoData.googleVerification);
            }
            const site = emptyForm(SITE_KEYS);
            SITE_KEYS.forEach((key: string) => site[key] = clean(siteData[key]));

            this.seo = seo;
            this.site = site;
            this.extraSeo = extra;
            this.loadedSiteId = seoSiteId;
            this.loadedSiteName = String(seoData._site_name || "");
            this.snapshot = this.serialize();
        } catch (e) {
            if (token === this.loadToken) {
                this.resetForm();
                this.loadError = this.errorText(e);
            }
            return;
        } finally {
            if (token === this.loadToken) {
                this.loading = false;
            }
        }
        await this.loadPreview();
    }

    seoPayload(): SeoForm {
        const payload: SeoForm = {};
        Object.keys(this.extraSeo).forEach((key: string) => payload[key] = this.extraSeo[key]);
        SEO_KEYS.forEach((key: string) => payload[key] = clean(this.seo[key]));
        // Doğrulama kodu tek anahtarda tutulur; eski anahtar temizlenir ki
        // panelden silinen kod eski anahtardan sitede basılmaya devam etmesin.
        payload.googleVerification = "";
        return payload;
    }

    sitePayload(): SeoForm {
        // Yalnızca bu ekranın alanları: sunucu gönderilmeyen anahtarları korur
        const payload: SeoForm = {};
        SITE_KEYS.forEach((key: string) => payload[key] = clean(this.site[key]));
        return payload;
    }

    async save() {
        if (!this.canSave) {
            return;
        }
        if (this.siteMismatch) {
            this.notify(false, "Aktif şube değişti; form yeniden yükleniyor. Değerleri kontrol edip tekrar kaydedin.");
            await this.load();
            return;
        }
        const branch = this.branchName;
        const savingSiteId = this.loadedSiteId;
        this.saving = true;
        this.result = null;
        let step = "seo";
        try {
            await this.$http.post("config/seo", this.seoPayload());
            step = "site";
            // X-Site-Id her istekte o anki aktif şubeden alınır; ilk kayıt
            // sürerken şube değiştiyse ek kodlar diğer şubeye yazılırdı.
            if (Number(this.activeSiteId) !== Number(savingSiteId)) {
                throw new Error("Aktif şube kayıt sırasında değişti; ek kodlar kaydedilmedi.");
            }
            await this.$http.post("config/site", this.sitePayload());
        } catch (e) {
            this.saving = false;
            const detail = this.errorText(e);
            this.notify(false, step === "seo"
                ? "Kaydedilemedi: " + detail
                : "İzleme ayarları kaydedildi ancak ek kodlar kaydedilemedi: " + detail);
            // Form korunur (tekrar denenebilsin); önizleme sunucudaki son durumu gösterir
            await this.loadPreview();
            return;
        }
        this.saving = false;
        this.lastSavedAt = new Date().toLocaleTimeString("tr-TR");
        this.notify(true, "Kaydedildi. Değerler " + (branch || "bu şubenin") + " sitesine yansıdı; diğer şube etkilenmedi.");
        await this.load();
    }

    notify(ok: boolean, text: string) {
        this.result = {ok: ok, text: text, visible: true};
        this.snackbar = {enabled: true, text: text, color: ok ? "success" : "error"};
    }

    errorText(e: any): string {
        let text = "";
        try {
            text = this.$helper.errorHandler(e);
        } catch (ignored) {
            text = "";
        }
        if (!text && e && e.response) {
            text = "Sunucu hatası (HTTP " + e.response.status + ")";
        }
        if (!text && e && e.message) {
            text = e.message;
        }
        return text || "Sunucuya ulaşılamadı.";
    }

    /* ------------------------------------------------------------------
     * Yaşam döngüsü
     * ---------------------------------------------------------------- */

    /**
     * Aktif şube değişince form hemen boşaltılır ve yeniden yüklenir:
     * bir şubenin değerleri diğer şubeye asla kaydedilemesin.
     */
    @Watch("$store.getters.activeSiteId")
    onActiveSiteChanged() {
        if (this.activeSiteId !== null && this.loadedSiteId !== null
            && Number(this.activeSiteId) === Number(this.loadedSiteId) && !this.loading) {
            return; // ör. ilk açılışta null → aynı (varsayılan) şube
        }
        this.resetForm();
        this.load();
    }

    onBeforeUnload(event: BeforeUnloadEvent) {
        // Şube değişimini kullanıcı zaten onayladıysa yenilemede ikinci kez sorulmaz
        if (this.dirty && !isLeaveConfirmed()) {
            event.preventDefault();
            event.returnValue = "";
        }
    }

    beforeRouteLeave(to: any, from: any, next: (value?: boolean) => void) {
        if (this.dirty && !window.confirm("Kaydedilmemiş değişiklikler var. Sayfadan çıkılsın mı?")) {
            next(false);
            return;
        }
        next();
    }

    created() {
        this.load();
    }

    mounted() {
        window.addEventListener("beforeunload", this.onBeforeUnload);
        // Başlıktaki şube seçici kaydedilmemiş değişiklik varken önce sorsun
        // ("Kal" denince şube değişip değerler kayboluyordu)
        this.unsavedGuard = () => this.dirty;
        registerUnsavedGuard(this.unsavedGuard);
    }

    beforeDestroy() {
        window.removeEventListener("beforeunload", this.onBeforeUnload);
        if (this.unsavedGuard) {
            unregisterUnsavedGuard(this.unsavedGuard);
            this.unsavedGuard = null;
        }
    }
}
